<template>
  <v-container
    id="detalhe-clientes-faturado-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <v-col
                cols="12"
              >
                <dashboard-filtro-datas
                  :primeiro="enablePrimeiroDia"
                  :ultimo="enableUltimoDia"
                  :empresas="enableEmpresa"
                  :supervisores="enableSupervisor"
                  :receitas="enableReceita"
                  :segmentos="enableSegmento"
                  :classificacoes="enableClassificacao"
                  :vendedores="enableVendedor"
                  :habilitar-filtros-data="enableFiltrosDados"
                />
              </v-col>
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-card
                        id="cardDashbord"
                        class="mx-auto"
                        outlined
                      >
                        <div class="card-header-dashbord">
                          <v-row>
                            <v-col
                              cols="12"
                              sm="9"
                              md="9"
                              lg="9"
                              class="d-flex flex-wrap"
                            >
                              Relatório Cobertura Vendedores
                            </v-col>
                            <v-col
                              cols="1"
                            >
                              <v-btn
                                id="btnPrint"
                                class="col-12 lg-12"
                                small
                                :color="corPrimaria"
                                dark
                                :disabled="enableBtn"
                                :loading="imprimindo"
                                @click="imprimir()"
                              >
                                <v-icon>
                                  mdi-printer
                                </v-icon>
                                Imprimir
                                <template v-slot:loader>
                                  <span>Imprimindo...</span>
                                </template>
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                              class="d-flex justify-end"
                            >
                              <v-tooltip top>
                                <template
                                  v-slot:activator="{ on, attrs }"
                                >
                                  <v-icon
                                    id="iconInformationClientesFaturados"
                                    class="text-left"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>Este relatório lista detalhes dos vendedores na data filtrada.</span><br>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </div>
                        <v-card-actions>
                          <v-row v-if="loading">
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                            </v-col>
                          </v-row>
                          <v-row v-else-if="error">
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row v-else>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                id="idTable"
                                style="overflow-x: auto;"
                              >
                                <table
                                  style="width: 100%; color: black; border-collapse: collapse;"
                                  class="elevation-1"
                                  mobile-breakpoint="0"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Vendedor
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Clientes Ativos
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Clientes Novos
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Positivados
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        % Postivação
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Sem Compra
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        % sem compra
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Núm. Total de Notas
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Ticket Médio
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        SKU's ativos
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Cobertura SKU's
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        % SKU's
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="item in dadosDetalhamento"
                                      :key="item.id"
                                    >
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.vendedor }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.cliente }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.novos }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.positivados }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.porcentagem }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.semCompra }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.porcentagemSemCompra }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.nota }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.ticket }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.skuProdutos }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.skuProdutosVendido }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.skuVariacao }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import eventEmit from '../../../components/core/EventoEmit'
  import Time from '../../../../../services/time3'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardClienteFaturadosDetalhamento',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      rede: [],
      ano: [],
      mes: [
        { texto: 'janeiro', valor: '01' }, { texto: 'fevereiro', valor: '02' }, { texto: 'março', valor: '03' },
        { texto: 'abril', valor: '04' }, { texto: 'maio', valor: '05' }, { texto: 'junho', valor: '06' },
        { texto: 'julho', valor: '07' }, { texto: 'agosto', valor: '08' }, { texto: 'setembro', valor: '09' },
        { texto: 'outubro', valor: '10' }, { texto: 'novembro', valor: '11' }, { texto: 'dezembro', valor: '12' },
      ],
      redeSelect: JSON.parse(localStorage.getItem('redesSelect')),
      anoSelect: localStorage.getItem('anoSelect'),
      mesSelect: JSON.parse(localStorage.getItem('mesSelect')),
      loading: false,
      error: null,
      dadosDetalhamento: [],
      enableBtn: true,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      supervisor: [],
      receita: [],
      segmento: [],
      areas: [],
      redes: [],
      classificacao: [],
      vendedores: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisor: true,
      enableReceita: true,
      enableSegmento: true,
      enableClassificacao: true,
      enableVendedor: true,
      enableFiltrosDados: false,
      menu: false,
      menu1: false,
      imprimindo: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        eventEmit.$emit('atualizar_texto', 'Time - Detalhe Cobertura Vendedor')
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.supervisor = supervisores
        this.receita = receita
        this.segmento = segmento
        this.classificacao = classificacao
        this.vendedores = vendedores

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('empresaId', JSON.stringify(this.select || []))
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.showDelhamentoAnaliseVendas()
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async showDelhamentoAnaliseVendas () {
        this.loading = true
        this.enableBtn = true

        await Time.showDetalheCoberturaVendedorTime(this.primeiroDia, this.ultimoDia, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, [], [], []).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.dadosDetalhamento = resposta.data.dados.map((item) => {
              var listaMelhoresClientes = ({
                vendedor: item.vendedor,
                cliente: item.cliente.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                novos: item.novos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                positivados: item.positivados.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                porcentagem: item.porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                semCompra: item.semCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                porcentagemSemCompra: item.porcentagemSemCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                nota: item.nota.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                ticket: item.ticket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                skuProdutos: item.skuProdutos,
                skuProdutosVendido: item.skuProdutosVendido,
                skuVariacao: item.skuVariacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
              })

              return listaMelhoresClientes
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      applyBoldClass (item) {
        return item.vendedor === 'Total' ? 'bold-row' : ''
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            posY = 20

            return posY
          }

          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          const titleTable = 'Relatório Cobertura Vendedores'
          const table = this.dadosDetalhamento.map(item => [item.vendedor, item.cliente, item.novos, item.positivados, item.porcentagem, item.semCompra, item.porcentagemSemCompra, item.ticket])
          posYFiltros = await addTable(table, this.headersDetalhamento, titleTable, posYFiltros, 8)

          pdf.save('relatorio_detalhe_cobertura_time.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      filtrarEmpresa () {
        this.filterSupervisor = []
        this.filterReceita = []
        this.filterSegmento = []

        if (this.select && this.select.length > 0) {
          this.select.forEach(empresa => {
            const supervisorAux = this.supervisor.filter(s => s.nomeBd === empresa.nome_bd)

            this.filterSupervisor.push(...supervisorAux)

            const receitaAux = this.receita.filter(rc => rc.nomeBd === empresa.nome_bd)

            this.filterReceita.push(...receitaAux)

            const segmentoAux = this.segmento.filter(sg => sg.nomeBd === empresa.nome_bd)

            this.filterSegmento.push(...segmentoAux)
          })
        }

        this.filterSupervisor.sort((a, b) => a.supervisor.localeCompare(b.supervisor))

        this.filterReceita.sort((a, b) => a.nome.localeCompare(b.nome))

        this.filterSegmento.sort((a, b) => a.segmento.localeCompare(b.nome))
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }

    #iconInformationClientesFaturados {
      margin: 0 0 0 1rem;
    }
  }

  @media screen
  and (min-width : 680px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #relatorioClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationClientesFaturados
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .bold-row td
    font-weight: bold

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
